//DELETE FEEDBACK
export const DELETE_FEEDBACK_REQUEST = "DELETE_FEEDBACK_REQUEST";
export const DELETE_FEEDBACK_SUCCESS = "DELETE_FEEDBACK_SUCCESS";
export const DELETE_FEEDBACK_FAILURE = "DELETE_FEEDBACK_FAILURE";

//GET FEEDBACK LIST
export const GET_FEEDBACK_LIST_REQUEST = "GET_FEEDBACK_LIST_REQUEST";
export const GET_FEEDBACK_LIST_SUCCESS = "GET_FEEDBACK_LIST_SUCCESS";
export const GET_FEEDBACK_LIST_FAILURE = "GET_FEEDBACK_LIST_FAILURE";